const DURATION_MS = 10 * 60 * 1000;

/**
 * Formats milliseconds remaining as MM:SS.
 * @param {number} ms
 * @returns {string}
 */
function formatRemaining(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/**
 * Starts (or restarts) the countdown on a given component instance.
 * @param {HTMLElement} el
 */
function startCountdown(el) {
  const timeEl = el.querySelector('[ref="countdownTime"]');
  if (!timeEl) return;

  if (el._cartCountdownInterval) {
    clearInterval(el._cartCountdownInterval);
  }

  const endsAt = Date.now() + DURATION_MS;

  function tick() {
    const remaining = endsAt - Date.now();
    timeEl.textContent = formatRemaining(remaining);

    if (remaining <= 0) {
      clearInterval(el._cartCountdownInterval);
      el._cartCountdownInterval = null;
    }
  }

  tick();
  el._cartCountdownInterval = setInterval(tick, 1000);
}

/**
 * Delegated listener: fires whenever any theme-drawer dispatches its open
 * event. We only react when the drawer that opened is the cart drawer.
 */
function onThemeDrawerOpen(event) {
  const drawer = event.target;
  if (!(drawer instanceof HTMLElement) || drawer.id !== 'cart-drawer') return;

  const countdown = document.getElementById('cart-countdown');
  if (!(countdown instanceof HTMLElement)) return;

  startCountdown(countdown);
}

/**
 * Fallback for two edge cases the 'theme-drawer:open' event can miss:
 * 1) The drawer was already open when this module finished loading (e.g.
 *    auto-open fired before this deferred module executed) - we'd never see
 *    that dispatch.
 * 2) The cart section was injected into the page via AJAX (Section
 *    Rendering API) rather than parsed natively by the browser on load -
 *    in that case THIS SAME <script> tag, if it only existed inside the
 *    cart markup, would never run at all. That's why this file is also
 *    loaded once per full page load (see layout/theme.liquid), independent
 *    of whether the cart section itself was server-rendered or AJAX-
 *    injected afterwards.
 */
function checkAlreadyOpen() {
  const drawer = document.getElementById('cart-drawer');
  const countdown = document.getElementById('cart-countdown');
  if (!drawer || !countdown) return;
  if (drawer.hasAttribute('open') && !countdown._cartCountdownInterval) {
    startCountdown(countdown);
  }
}

if (!window.__cartCountdownBound) {
  window.__cartCountdownBound = true;
  document.addEventListener('theme-drawer:open', onThemeDrawerOpen);
}

checkAlreadyOpen();
